import React, { Component } from 'react';
import { Button, Divider, Form } from 'semantic-ui-react';
import { change, Field, formValueSelector, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { find } from 'lodash';
import * as classnames from 'classnames';
import PhotoBoothModal from '../../../../../../../containers/PhotoBoothModal';
import {
  Tech3Radio,
  Tech3RCheckbox,
  Tech3Select
} from '../../../../../../../components/FormElements';
import { required } from '../../../../../../../lib/FormValidators';

const occurrenceSignalFormName = 'occurrenceSignal';
const occurrenceEventFormSelector = formValueSelector(occurrenceSignalFormName);

class SignalForm extends Component {
  constructor(props) {
    super(props);

    this.setEquipmentType = this.setEquipmentType.bind(this);
    this.setSignalId = this.setSignalId.bind(this);
  }

  setEquipmentType(id) {
    this.props.changeFieldValue('dimensions', []);
    this.props.changeFieldValue('signal_id', null);
    this.props.changeFieldValue('hardware_id', null);
    this.props.changeFieldValue('software_id', null);
    this.props.changeFieldValue('version_id', null);
  }

  setSignalId(id) {
    let dimensions = [];
    const currentSignal = find(this.props.selectedEquipment.signals, { id });
    if (currentSignal) {
      dimensions = currentSignal.dimensions.map(dimension => {
        return dimension.id;
      });
    }

    this.props.changeFieldValue('dimensions', dimensions);
    this.props.changeFieldValue('hardware_id', null);
    this.props.changeFieldValue('software_id', null);
    this.props.changeFieldValue('version_id', null);
  }

  setHardwareId() {
    this.props.changeFieldValue('software_id', null);
    this.props.changeFieldValue('version_id', null);
  }

  setSoftwareId() {
    this.props.changeFieldValue('version_id', null);
  }

  render() {
    const self = this;
    const equipments = this.props.equipmentData.map((type, i) => {
      return {
        key: `equipment_${type.id}`,
        text: type.name,
        value: type.id
      };
    });

    let signals = [];
    let hardwares = [];
    let softwares = [];
    let versions = [];

    if (this.props.selectedEquipment) {
      signals = this.props.selectedEquipment.signals.map((signal, i) => {
        const dimensions = signal.dimensions.map((dimension, k) => {
          return (
            <Field
              key={dimension.id}
              component={Tech3RCheckbox}
              name="dimensions"
              isArray
              idCheck={`dimension_${dimension.id}`}
              checkValue={dimension.id}
              validate={[required]}
              label={dimension.name}
            />
          );
        });

        const dimensionsClasses = classnames({
          dimensionContainer: true,
          hidden: !self.props.selectedSignal || self.props.selectedSignal.id !== signal.id
        });

        return (
          <div className="singleContainer" key={i}>
            <div className="radio">
              <Field
                key={signal.id}
                component={Tech3Radio}
                name="signal_id"
                idRadio={`signal_${signal.id}`}
                radioValue={signal.id}
                label={signal.name}
                validate={[required]}
                onChange={(event, newValue, previousValue) => {
                  if (newValue === signal.id) {
                    this.setSignalId(newValue);
                  }
                }}
              />
            </div>
            <div className={dimensionsClasses}>{dimensions}</div>
          </div>
        );
      });
    }

    if (this.props.selectedSignal) {
      hardwares = this.props.selectedSignal.hardware.map((hardware, i) => {
        return (
          <div className="singleContainer" key={i}>
            <div className="radio">
              <Field
                key={hardware.id}
                component={Tech3Radio}
                validate={[required]}
                name="hardware_id"
                idRadio={`hardware_${hardware.id}`}
                radioValue={hardware.id}
                label={hardware.name}
                onChange={(event, newValue, previousValue) => {
                  this.setHardwareId();
                }}
              />
            </div>
          </div>
        );
      });
    }

    if (this.props.selectedHardware) {
      softwares = this.props.selectedHardware.software.map((software, i) => {
        return (
          <div className="singleContainer" key={i}>
            <div className="radio">
              <Field
                key={software.id}
                component={Tech3Radio}
                validate={[required]}
                name="software_id"
                idRadio={`software_${software.id}`}
                radioValue={software.id}
                label={software.name}
                onChange={(event, newValue, previousValue) => {
                  this.setSoftwareId();
                }}
              />
            </div>
          </div>
        );
      });
    }

    if (this.props.selectedSoftware) {
      versions = this.props.selectedSoftware.versions.map((version, i) => {
        return (
          <div className="singleContainer" key={i}>
            <div className="radio">
              <Field
                key={version.id}
                component={Tech3Radio}
                validate={[required]}
                name="version_id"
                idRadio={`version_${version.id}`}
                radioValue={version.id}
                label={version.name}
              />
            </div>
          </div>
        );
      });
    }

    return (
      <PhotoBoothModal {...this.props}>
        <Form id="addSignalForm" onSubmit={this.props.handleSubmit}>
          {this.props.initialValues && this.props.initialValues.id ? (
            <h2>Edit Signal</h2>
          ) : (
            <h2>Create new Signal</h2>
          )}

          <Field
            label="Select Signal type:"
            name="equipment_id"
            options={equipments}
            placeholder="Choose Signal..."
            component={Tech3Select}
            upward={false}
            validate={[required]}
            onChange={(event, newValue, previousValue) => {
              this.setEquipmentType(newValue);
            }}
          />

          {signals.length > 0 && (
            <div>
              <Divider />
              <h3>Select the Signal to capture.</h3>
              <div className="radioContainer">{signals}</div>
            </div>
          )}
          {this.props.selectedSignal &&
            this.props.selectedSignal.hardware &&
            this.props.selectedSignal.hardware.length > 0 && (
              <div>
                <Divider />
                <h3>Select the Hardware</h3>
                <div className="radioContainer">{hardwares}</div>
              </div>
            )}
          {this.props.selectedHardware &&
            this.props.selectedHardware.software &&
            this.props.selectedHardware.software.length > 0 && (
              <div>
                <Divider />
                <h3>Select the Software</h3>
                <div className="radioContainer">{softwares}</div>
              </div>
            )}
          {this.props.selectedSoftware &&
            this.props.selectedSoftware.versions &&
            this.props.selectedSoftware.versions.length > 0 && (
              <div>
                <Divider />
                <h3>Select the Version</h3>
                <div className="radioContainer">{versions}</div>
              </div>
            )}
          <Button type="submit" disabled={this.props.submitting}>
            Submit
          </Button>
        </Form>
      </PhotoBoothModal>
    );
  }
}

SignalForm.propTypes = {
  ...PhotoBoothModal.propTypes
};

SignalForm.defaultProps = { ...PhotoBoothModal.defaultProps };

const signalForm = reduxForm({
  form: occurrenceSignalFormName,
  enableReinitialize: true
})(SignalForm);

const getSelectedEquipment = (state, equipmentData) => {
  return find(equipmentData, {
    id: parseInt(occurrenceEventFormSelector(state, 'equipment_id'), 10)
  });
};

const getSelectedSignal = (state, equipmentData) => {
  let signal;

  const selectedEquipment = getSelectedEquipment(state, equipmentData);

  if (selectedEquipment) {
    signal = find(selectedEquipment.signals, {
      id: parseInt(occurrenceEventFormSelector(state, 'signal_id'), 10)
    });
  }

  return signal;
};

const getSelectedHardware = (state, equipmentData) => {
  let hardware;

  const selectedSignal = getSelectedSignal(state, equipmentData);

  if (selectedSignal) {
    hardware = find(selectedSignal.hardware, {
      id: parseInt(occurrenceEventFormSelector(state, 'hardware_id'), 10)
    });
  }

  return hardware;
};

const getSelectedSoftware = (state, equipmentData) => {
  let software;

  const selectedHardware = getSelectedHardware(state, equipmentData);

  if (selectedHardware) {
    software = find(selectedHardware.software, {
      id: parseInt(occurrenceEventFormSelector(state, 'software_id'), 10)
    });
  }

  return software;
};

export default connect(
  state => ({
    equipmentData: state.projects.single.experimentalDesign.signalTypes,
    selectedEquipment: (() => {
      return getSelectedEquipment(state, state.projects.single.experimentalDesign.signalTypes);
    })(),
    selectedSignal: (() => {
      return getSelectedSignal(state, state.projects.single.experimentalDesign.signalTypes);
    })(),
    selectedHardware: (() => {
      return getSelectedHardware(state, state.projects.single.experimentalDesign.signalTypes);
    })(),
    selectedSoftware: (() => {
      return getSelectedSoftware(state, state.projects.single.experimentalDesign.signalTypes);
    })()
  }),
  dispatch => {
    return {
      changeFieldValue(field, value) {
        dispatch(change(occurrenceSignalFormName, field, value));
      }
    };
  }
)(signalForm);



// WEBPACK FOOTER //
// ./src/scenes/projects/scenes/singleProject/components/experimentalDesign/modals/SignalForm.js